export default class Websockets {
  constructor(Vue) {
    this.portal = Vue.prototype.$portal;
    this.company = Vue.prototype.$company;
    this.user = Vue.prototype.$user;
  }

  setupNotificationsWS() {
    this.notificationsWS = new WebSocket(this.portal.url.endPoint.ws_notifications);

    this.notificationsWS.onopen = () => {
      this.notificationsWS.send(
        JSON.stringify({
          action: 'subscribe',
          app: this.company.json.id,
          code: this.user.token,
          client: window.sessionStorage.getItem('notificationClientId'),
        }),
      );
    };
  }

  readNotification(identifier) {
    this.notificationsWS.send(
      JSON.stringify({
        action: 'read',
        app: this.company.json.id,
        code: this.user.token,
        identifier,
      }),
    );
  }

  close() {
    this.notificationsWS.close();
  }
}